import Layout from "./Layout"
const products = [
    {
        id: 1,
        name: 'The Bike Guy',
        href: '#',
        price: 'Download',
        imageSrc: '/schoolweb/b2.avif',
        imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    },
    {
        id: 2,
        name: 'Win-Win Strategy',
        href: '#',
        price: 'Download',
        imageSrc: '/schoolweb/b.avif',
        imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
    },
    {
        id: 3,
        name: 'Looks good on Paper',
        href: '#',
        price: 'Download',
        imageSrc: '/schoolweb/b3.avif',
        imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
    },
    {
        id: 4,
        name: 'The Vintage Book',
        href: '#',
        price: 'Download',
        imageSrc: '/schoolweb/b4.avif',
        imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
    },

]

export default function Library() {
    return (
        <Layout>
            <div className="bg-white">
                <div className="mx-auto max-w-2xl px-8 py-16 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
                    <h2 className="text-center mb-8 md:mb-12 text-2xl font-semibold font-roboto text-[#0a1a42]">Download E-Books</h2>

                    <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
                        {products.map((product) => (
                            <a key={product.id} href={product.href} className="group">
                                <div className="lex justify-center">
                                    <img
                                        src={product.imageSrc}
                                        alt={product.imageAlt}
                                        className="max-[760px]:px-8 w-[600px] md:h-[300px]"
                                    />
                                </div>
                                <div className="px-8">
                                    <h3 className="mt-4 text-sm text-gray-700">{product.name}</h3>
                                    <p className="mt-1 text-lg font-medium text-gray-900">{product.price}</p>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    )
}
